import { EventEmitter, Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventEmitterService {

  invokeItemModalFunction = new EventEmitter();    
  invokeSettingsModalFunction = new EventEmitter();    
  subsVar: Subscription;    
    
  constructor() { }    
    
  onItemEditClick(item : any) {    
    this.invokeItemModalFunction.emit(item);    
  }    


  onRefreshItemCount(){
    this.invokeItemModalFunction.emit(true)
  }

  // onMenuSettingsClick(item : any) {    
  //   this.invokeSettingsModalFunction.emit(item);    
  // }   
}
